import { CroppingSuitabilityReportModel } from "@agroyaar/sdk";
import Title from "@/shared/components/report-template/presentation/components/common/Title";
import ReportTemplate from "@/shared/components/report-template/presentation/components/ReportTemplate";
// @ts-ignore
import image from "@assets/images/cropping-suitability/definition-cropping-suitability-mc.png";

interface CroppingSuitabilityDefinitionProps {
  croppingSuitabilityReports: CroppingSuitabilityReportModel[];
}

const CroppingSuitabilityDefinition = ({
  croppingSuitabilityReports,
}: CroppingSuitabilityDefinitionProps) => {
  return (
    <ReportTemplate serviceType="CROPPING_SUITABILITY" pageNumber={1}>
      <div className="w-full flex flex-col gap-6">
        <Title> تعریف تناسب کشت </Title>

        <ul className=" list-disc list-inside flex flex-col gap-3">
          <li className="leading-[28px] !font-[B-Nazanin] text-[16px]">
            تناسب کشت یا تناسب اراضی، سنجشی از میزان سازگاری ویژگی‌های یک قطعه
            زمین با نیازهای زیستی و مدیریتی یک محصول کشاورزی خاص است. این
            ارزیابی با هدف تعیین کارایی و بهره‌وری زمین در تولید محصول مورد نظر
            انجام می‌شود و به تصمیم‌گیری بهینه در تخصیص کاربری اراضی، انتخاب
            محصولات مناسب و مدیریت منابع کمک می‌کند.
          </li>
        </ul>

        <div className="border-2 border-dashed border-president rounded-lg p-4 my-8">
          <p className=" text-[18px] font-bold leading-[28px] !font-[B-Nazanin]">
            این گزارش با هدف ارزیابی میزان تناسب زمین مورد نظر برای محصولات{" "}
            <span className="font-semibold text-[18px] leading-[28px] !font-[B-Nazanin] text-president">
              {croppingSuitabilityReports
                .map((cropReport) => cropReport.crop.persianName)
                .join("، ")}
            </span>
            تهیه شده تا امکان تصمیم‌گیری دقیق‌تر و علمی‌تر فراهم شود.
          </p>
        </div>
        <div className="w-full flex justify-center items-center">
          <div className="w-full h-[350px]">
            <img className="w-full h-full" src={image} alt="definition" />
          </div>
        </div>
      </div>
    </ReportTemplate>
  );
};

export default CroppingSuitabilityDefinition;
